import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'

import Home from '../views/Home'
import Register from '../views/Register'
import Confirm from '../views/Confirm.vue'
import Profile from '../views/Profile'
import Project from '../views/Project'
import Article from '../views/Article'
import Craft from '../views/Craft'
import Settings from '../views/Settings'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import TermsOfService from '../views/TermsOfService.vue'
import Sponsors from '../views/Sponsors.vue'
import Faq from '../views/Faq'
import Recover from '../views/Recover'
import Search from '../views/Search'
import Stores from '../views/Stores'
import Collections from '../views/Collections'
import Moderation from '../views/Moderation'
import NotFound from '../views/NotFound'
import Skills from '@/views/Skills'
import News from '@/views/News'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: { requiresUnauth: true }
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: Confirm,
    meta: { requiresUnauth: true }
  },
  {
    path: '/users/:username',
    name: 'profile',
    component: Profile
  },
  {
    path: '/users/:username/collections',
    name: 'collections',
    component: Collections
  },
  {
    path: '/projects/:projectId',
    name: 'project',
    component: Project
  },
  {
    path: '/articles/:articleId',
    name: 'article',
    component: Article
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: { requiresAuth: true }
  },
  {
    path: '/crafts/:craftId',
    name: 'craft',
    component: Craft
  },
  {
    path: '/sponsors',
    name: 'sponsors',
    component: Sponsors
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/privacy-policy',
    name: 'privacypolicy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-of-service',
    name: 'termsofservice',
    component: TermsOfService
  },
  {
    path: '/faq',
    name: 'faq',
    component: Faq
  },
  {
    path: '/recover',
    name: 'recover',
    component: Recover
  },
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  {
    path: '/stores/:store',
    name: 'stores',
    component: Stores
  },
  {
    path: '/skills/:skill',
    name: 'skills',
    component: Skills
  },
  {
    path: '/moderation',
    name: 'moderation',
    component: Moderation
  },
  {
    path: '/news',
    name: 'news',
    component: News
  },
  {
    path: '*',
    name: 'notfound',
    component: NotFound
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/')
  } else if (to.matched.some(record => record.meta.requiresUnauth)) {
    if (!store.getters.isLoggedIn) {
      next()
      return
    }
    next('/')
  } else {
    next()
  }
})

export default router
